"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const index_1 = require("../index");
const sizeToScale = {
    4: 0.9,
    3: 0.7,
    2: 0.5,
    1: 0.3,
    0: 0.2,
};
function ColorButton({ color, active, size, opacity, onClick, }) {
    return ((0, jsx_runtime_1.jsx)(StyledActionButton, { active: active, onClick: onClick, "data-e2e": 'ColorButton_StyledActionButton', children: (0, jsx_runtime_1.jsx)(Indicator, { "$color": color, "$size": sizeToScale[size], "$opacity": opacity, "data-e2e": 'ColorButton_Indicator' }) }));
}
exports.default = ColorButton;
const StyledActionButton = (0, styled_components_1.default)(index_1.ActionButton) `
  width: 36px;
  height: 36px;

  margin: auto 0;

  &::before {
    transform: scale(${({ active }) => (active ? 1.5 : 1.2)});
  }
`;
const Indicator = styled_components_1.default.div `
  position: absolute;

  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background-image: ${props => props.theme.chessBackground};
  background-position: 0 0, 0 10px, 10px -10px, -10px 0;
  background-size: 20px 20px;

  border-radius: 50%;

  transform: scale(${props => props.$size});

  transition-timing-function: ease-in;
  transition-duration: 0.2s;
  transition-property: transform;

  &::after {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    background-color: ${props => props.$color};
    border-radius: 50%;

    opacity: ${props => props.$opacity};

    content: ' ';
  }
`;
